<template>
    <div id="app">
        <v-app>
            <v-main>
<!--                <Container></Container>-->
                <router-view>

                </router-view>
            </v-main>
        </v-app>
    </div>
</template>

<script>
    import Container from './components/Container'
    export default {
        components: {
            // Container
        },
        name: 'imenafzar'
    }
</script>
<style>
    @import './assets/my_style.css';
</style>
